import type { DriveSafe } from '@vivport/backend/types';

export function DrivesReadOnlyList({ drives }: { drives: DriveSafe[] }) {
  if (drives.length === 0) {
    return <p className="text-sm text-muted-foreground">No drives yet.</p>;
  }
  return (
    <ul className="divide-y">
      {drives.map((drive) => (
        <li key={drive.id} className="py-2">
          <p className="text-sm font-medium">{drive.name}</p>
          <p className="text-xs text-muted-foreground">
            {drive.productLabel} · {drive.roots.length} root{drive.roots.length === 1 ? '' : 's'}
          </p>
        </li>
      ))}
    </ul>
  );
}
